<template lang="pug">
    .card-wrapper
      .card-renewal-wrapper
      .license-box(v-if="license")
        span(:class="{'expired':license.expired}")
          em(v-if="license.expired") Pendiente de renovación
          em(v-if="!license.expired") Renovación en {{license.remaining}}
      .row
        .col-8.col-sm-8.col-md-8
          h1.info-name {{user.first_name}} {{user.last_name}}
          hr
          .info-block(v-if="license")
            label Licencia
            span {{license.license}}
          hr
          .info-block
            label Tipo de registro
            span Profesional de ejercicio registrado
          hr
          .info-block(v-if="user.renovation_link")
            a.renewal-link(:href="callback") Renovar icencia
        .col-4.col-sm-4.col-md-4
          img(src="/static/img/avatar/avatar-perfil-3.png")

</template>

<script>
export default {
  name: 'DashboardCard',
  props: ["user"],
  computed: {
    callback: function() {
      return `${this.user.renovation_link}&callback=${this.domain}/registro-profesional/final`
    }
  },
  data() {
    return {
      license: null,
      domain: '',
    }
  },
  created() {
    this.domain = `${window.location.protocol}//${window.location.host}`

    // TODO: Multiple licenses for now, in a future multiple rows
    if (this.user.licenses.length) this.license = this.user.licenses[0];
  }
}

</script>

<style scoped lang="scss">
@import "./../../variables";

.card-wrapper {
    position: relative;
    width: 100%;
    height: auto;
    padding-top: $gutter*3;
    padding-left: $gutter;
    padding-right: $gutter;
    color: $color-white;
}

.info-name {
    font-size: 1.34em;
}

.info-block {
    font-size: 0.9em;

    label {
        display: inline-block;
        margin-right: 12px;
        font-weight: 700;
    }
}

hr {
    border-top: 2px solid lighten($color-grey, 3%);
    border-style: dotted;
}

.license-box {
    position: absolute;
    top: -1*$gutter;
    right: 0;
    width: 50%;
    text-align: center;
    display: inline-block;

    span {
        display: inline-block;
        background-color: $color-primary;
        padding: 2px 6px;
        font-size: 0.85em;
        color: $color-black;
    }

    em {
        font-style: normal;
    }

    span.expired {
        background-color: red;
        color: $color-white;
    }
}

img {
    width: 70%;
    margin: 0 auto;
    display: block;
    height: auto;
}

.renewal-link {
  color: #000;
  background-color: $color-accent;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 9px 24px;
  font-weight: 700;
  font-size: 1.2em;
  margin: 0.3em 0 1em 0;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCard.vue